import { LevelEntity } from 'shared/domain/level/types/entity';
import { SiteEntity } from 'shared/domain/site/types/entity';
import { debugLog } from 'shared/logger/debugLog';

export const createDocumentationSitesAndLevelsMap = (
  sites: SiteEntity[],
  levels: LevelEntity[]
): {
  docSitesMap: Map<string, SiteEntity[]>;
  docLevelsMap: Map<string, LevelEntity[]>;
} => {
  const docSitesMap = new Map<string, SiteEntity[]>();
  const docLevelsMap = new Map<string, LevelEntity[]>();

  levels.forEach((level) => {
    if (!level.maps || !Array.isArray(level.maps)) {
      debugLog(
        'createDocumentationSitesAndLevelsMap: Level has no maps:',
        level
      );
      return;
    }

    const site = sites.find((s) => s._id === level.site);
    if (!site) {
      debugLog(
        'createDocumentationSitesAndLevelsMap: Site not found for siteId:',
        level.site
      );
      return;
    }

    level.maps.forEach((mapItem) => {
      if (mapItem.documentationId) {
        const key = mapItem.documentationId;

        const existingSites = docSitesMap.get(key) || [];
        if (!existingSites.includes(site)) {
          existingSites.push(site);
          docSitesMap.set(key, existingSites);
        }

        const existingLevels = docLevelsMap.get(key) || [];
        if (!existingLevels.includes(level)) {
          existingLevels.push(level);
          docLevelsMap.set(key, existingLevels);
        }
      }
    });
  });

  return { docSitesMap, docLevelsMap };
};
